<template>
	<div>
		<v-data-table
			:headers="headers"
			:items="filteredInventoryItems"
			:loading="loading"
			:height="pageHeight(176)"
			:search="appBarSearch"
			dense
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')">
			<template #item="{ item, index }">
				<tr class="text-left" :class="{ 'odd-row': index % 2 }">
					<td>{{ item.itemModel?.name }}</td>
					<td :style="{ color: item.organization?.institutionName ? 'black' : 'red' }">
						{{ item.organization?.institutionName ?? $t('unassigned') }}
					</td>
					<td :style="{ color: item.location?.hospitalName ? 'black' : 'red' }">
						{{ item.location?.hospitalName ?? $t('unassigned') }}
					</td>
					<td>{{ item.sellPrice }} {{ item.sellCurrency }}</td>
					<td>{{ item.shipmentCost }} {{ item.shipmentCurrency }}</td>
					<td>{{ item.status }}</td>
					<td>{{ item.shipmentDate ? formatterFilter(item.shipmentDate, 'date_med') : '-' }}</td>
					<td class="text-right">
						<v-icon color="primary" @click="openDetailsDialog(item)">mdi-eye</v-icon>
						<v-icon color="primary" @click="openEditDrawer(item)">mdi-pencil</v-icon>
						<v-icon
							color="primary"
							@click="
								deletingId = item.id;
								showDeleteDialog = true;
							">
							mdi-delete
						</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
		<DeleteDialog
			:dialog.sync="showDeleteDialog"
			@confirm="
				showDeleteDialog = false;
				deleteInventoryItem(deletingId);
			" />
		<ItemViewDialog
			v-if="selectedItem"
			:selectedItem="selectedItem"
			:showDialog.sync="showDetailsDialog"
			@closeDialog="showDetailsDialog = false" />
	</div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';
import ItemViewDialog from '../../dialogs/ItemViewDialog.vue';
import { formatterFilter } from '@/utils/luxon-formater';

export default {
	name: 'InventoryItems',
	components: { DeleteDialog, ItemViewDialog },
	data () {
		return {
			loading: true,
			deletingId: -1,
			showDeleteDialog: false,
			showDetailsDialog: false,
			selectedItem: null,
		};
	},
	computed: {
		...mapState({
			inventoryItems: (state) => state.inventoryItems.inventoryItems,
		}),
		...mapGetters({
			pageHeight: 'pageHeight',
			appBarSearch: 'filterbar/getSearch',
			appBarMedicalInstitution: 'filterbar/getMedicalInstitution',
			selectedHospitalId: 'filterbar/getHospitalId',
		}),
		headers () {
			return [
				{ text: this.$t('item-name'), value: 'itemModel.name' },
				{ text: this.$t('organization-name'), value: 'organization.institutionName' },
				{ text: this.$t('hospital-name'), value: 'location.hospitalName' },
				{ text: this.$t('sell-price'), value: 'sellPrice' },
				{ text: this.$t('shipment-cost'), value: 'shipmentCost' },
				{ text: this.$t('status'), value: 'status' },
				{ text: this.$t('shipment-date'), value: 'shipmentDate' },
				{ text: this.$t('actions'), value: 'actions', align: 'end' },
			];
		},
		filteredInventoryItems () {
			return this.inventoryItems
				.filter((item) => item.organizationId === this.appBarMedicalInstitution || !this.appBarMedicalInstitution)
				.filter(
					(item) =>
						item.locationId === this.selectedHospitalId ||
						this.selectedHospitalId === null ||
						this.selectedHospitalId === -99,
				);
		},
	},
	async mounted () {
		await this.getInventoryItems();
		this.loading = false;
	},
	methods: {
		formatterFilter,
		...mapActions({
			getInventoryItems: 'inventoryItems/getInventoryItems',
			deleteInventoryItem: 'inventoryItems/deleteInventoryItem',
		}),
		async openEditDrawer (item) {
			await this.$store.commit('inventoryItems/SET_INVENTORY_ITEM', item);
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'inventoryItemEdit',
			});
		},
		openDetailsDialog (item) {
			this.selectedItem = item;
			this.showDetailsDialog = true;
		},
	},
};
</script>
